// PostHog feature flag keys. Values must match the flag keys in PostHog.
// Usage: isPostHogFlagEnabled(POSTHOG_FLAGS.INTEGRATED_PYLON_WIDGET)
export const POSTHOG_FLAGS = {
  INTEGRATED_PYLON_WIDGET: 'integrated-pylon-widget',
  SHOW_OPPORTUNITY_STATUS_DROPDOWN: 'show-opportunity-status-dropdown',
  TELEHEALTH_DIAGNOSTICS: 'telehealth-diagnostics',
  VYTAL_INSIGHTS: 'vytal-insights',
};
